window.onSignIn = function(googleUser) {
  // Useful data for your client-side scripts:

  // The ID token you need to pass to your backend:
  var id_token = googleUser.getAuthResponse().id_token;
  $('#google_auth_token').val(id_token);
  // $('#id_username').val(googleUser.Rt.Bu);
  gapi.auth2.getAuthInstance().disconnect().then(function () {
      $('#sofisis-form-login').submit();
  });
};